
export const getSafeModeHeaders = (featureKeys) => {
    const isSafeModeFeatureEnabled = featureKeys && featureKeys["NetApp.TenancyV4/safemode"]?.active;
    return isSafeModeFeatureEnabled ? {
                headers: {
                    'Accept': 'application/vnd.netapp.bxp.user.safemode+json'
                }
        } : {};
}

/**
 * Decodes a base64url-encoded string to a regular string.
 * Handles URL-safe characters and padding required for standard base64 decoding.
 * 
 * @param {string} str - The base64url-encoded string to decode
 * @returns {string} The decoded string
 */
export const base64UrlDecode = (str) => {
    // Replace URL-safe characters
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    // Pad with '='
    while (str.length % 4) {
        str += '=';
    }
    // Decode
    return atob(str);
}